import { themeToggle } from "./modules/themeToggle";
import { themeAutodetect } from "./modules/themeAutodetect";
import { initParallax } from "./modules/parallax";
import { initPortfolioMenu } from "./modules/portfolioMenu";
import { initBackToTop } from "./modules/backToTop";
import { addSmoothScrollingToAnchors } from "./modules/anchorSmoothScroll";
import { initPageLoader } from "./modules/pageLoader";
import { switchUrls } from "./modules/switchUrls";
import { AeroCard } from "@ohkimur/aero/dist/components/aero-card";
import { AeroGrid } from "@ohkimur/aero/dist/components/aero-grid";

// Wait for the DOM to be loaded.
window.addEventListener("DOMContentLoaded", (_event: Event) => {
  themeAutodetect();
  switchUrls();
  themeToggle();
  initParallax();
  initBackToTop();
  initPortfolioMenu("portfolioMenu");
  initPageLoader();
  addSmoothScrollingToAnchors();
  customElements.define("aero-card", AeroCard);
  customElements.define("aero-grid", AeroGrid);
});
